// extracted by mini-css-extract-plugin
export default {"main":"GraphError--main--1NeG9","img":"GraphError--img--7HcWP","title":"GraphError--title--86JKq","secondLink":"GraphError--secondLink--s2G+P"};